(function () {
    'use strict';

    run.admin.pages.extensionChromeAuthorizing = function() {
        const dataSource = document.getElementById('redirect_data');

        if (dataSource !== null && dataSource !== 'undefined') {
            const url = dataSource.dataset.url + '?extension_authorized=chrome';
            //console.log(url);

            setTimeout(() => {
                window.location.replace(url);
            }, 2500);
        }

        const url = new URL(window.location.href);
        if (url.searchParams.has('extension_authorized')) {
            Swal.fire({
                title: translations.extensions.chrome.authorized.title,
                html: translations.extensions.chrome.authorized.html,
                confirmButtonText: translations.extensions.chrome.authorized.buttonConfirm,
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            });
        }
    }
})();
